import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ITelegramAdminUsersResponse } from './telegram-admin-users-response';
import { telegramAdminUsersResponseSchema } from './telegram-admin-users-response';

export async function getTelegramAdminUsersApi(
  cursor?: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ITelegramAdminUsersResponse>> {
  return getRequest<ITelegramAdminUsersResponse>({
    path: '/sys/telegram/users',
    schema: telegramAdminUsersResponseSchema,
    options: {
      ...options,
      params: cursor ? { cursor } : undefined,
    },
  });
}
